<template>
  <div class="distribution-bar-chart">
    <div class="distribution-bar-chart__track">
      <BaseChartTooltip
        v-for="(item, index) in itemsWithHeight"
        :key="index"
        :label="`${item.label}: ${item.value}`"
        class="distribution-bar-chart__col"
        :data-field="dataFieldFor(index)"
      >
        <span class="distribution-bar-chart__value">{{ item.value }}</span>
        <span
          class="distribution-bar-chart__fill"
          :style="{ height: `${item.heightPct}%` }"
        />
      </BaseChartTooltip>
    </div>
    <div class="distribution-bar-chart__labels">
      <span
        v-for="(item, index) in items"
        :key="index"
        class="distribution-bar-chart__label"
        :data-field="dataFieldFor(index)"
      >{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
import BaseChartTooltip from './BaseChartTooltip.vue'
import DataFieldByIndex from './DataFieldByIndex'

export default {
  name: 'BaseDistributionBarChart',
  components: { BaseChartTooltip },
  mixins: [DataFieldByIndex],
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    itemsWithHeight() {
      const max = this.items.reduce((acc, item) => Math.max(acc, item.rawValue || 0), 0)
      return this.items.map((item) => ({
        ...item,
        heightPct: max > 0 ? ((item.rawValue || 0) / max) * 100 : 0
      }))
    }
  }
}
</script>

<style lang="scss">
.distribution-bar-chart {
  &__track {
    display: flex;
    align-items: flex-end;
    gap: 16px;
    height: 130px;
    padding: 10px 8px 0;
    border-bottom: 1px solid var(--ds-color-black-010);
  }

  &__col {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    width: auto;
  }

  &__fill {
    width: 60%;
    background: var(--v-bluefa-base);
    border-radius: 3px 3px 0 0;
    min-height: 3px;
    display: block;
  }

  &__value {
    font-size: 11px;
    font-weight: 700;
    margin-bottom: 4px;
    color: var(--v-textPrimary-base);
  }

  &__labels {
    display: flex;
    gap: 16px;
    padding: 0 8px;
    margin-top: 8px;
  }

  &__label {
    flex: 1;
    text-align: center;
    font-size: 11.5px;
    color: var(--ds-color-black-040);
  }
}
</style>
